import axios from 'axios/dist/axios'

export default {
  reportError (type, message, details, system, route, user, version) {
    let data = {
      action: 'reportError',
      token: process.env.VUE_APP_DIAGNOSTIC_TOKEN,
      payload: {type, message, details, system, route, user, version}
    }

    return axios.create().post(process.env.VUE_APP_DIAGNOSTIC_ENDPOINT, data).then(response => {
      return Promise.resolve(response.data)
    })
  }
}